/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupprofileorganizerdescription3Inputs */

const en_setupprofileorganizerdescription3 = /** @type {(inputs: Setupprofileorganizerdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You organize events, also at changing venues.`)
};

const de_setupprofileorganizerdescription3 = /** @type {(inputs: Setupprofileorganizerdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du organisierst Veranstaltungen, auch an wechselnden Orten.`)
};

/**
* | output |
* | --- |
* | "You organize events, also at changing venues." |
*
* @param {Setupprofileorganizerdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupprofileorganizerdescription3 = /** @type {((inputs?: Setupprofileorganizerdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupprofileorganizerdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupprofileorganizerdescription3(inputs)
	return de_setupprofileorganizerdescription3(inputs)
});
export { setupprofileorganizerdescription3 as "setupProfileOrganizerDescription" }